export const LE_BUSINESS_TRAVELLER = 'lebusinesstraveller'
export const LUXURY_ESCAPES = 'luxuryescapes'
